import React from 'react';
import './Navbar.css';

function Navbar() {
  return (
    <header className="navbar">
      <img 
        src="https://framerusercontent.com/images/4ZVv30qkcbggct3OjppstoUPc.png" 
        alt="Vitalinsights Logo" 
        className="logo"
      />
      <a href="https://vitalinsights.in/" target="_blank" rel="noopener noreferrer" className="about-btn">About us</a>
    </header>
  );
}

export default Navbar;
